/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  notification,
  Modal,
  Upload,
} from "antd";
import { PanelHeader, Panel, PanelBody } from "../../../../util/panel";
import { axios, getToken, URL_API, _ } from "../../../../../utils";
import TextEditor from "../../../../../components/TextEditor";
import {
  base64toFile,
  beforeUploadImg,
  fileToBase64,
  resizeFile,
} from "../../../../util/helper";
import { AiOutlineUpload } from "react-icons/ai";
import { DivStyles, ImgStyles } from "../../components/mwStyles";
import useUploadFile from "../../components/useUploadFile";
import { dummyRequest } from "../../components/dummyRequest";

function Award({ history, form, match, ...props }) {
  const [loadValue, setLoadValue] = useState("");

  const [contentTextEditor, setContentTextEditor] = useState();
  const [fileListDesktop, setFileListDesktop] = useState([]);
  const [fileDelete, setFileDelete] = useState([]);

  let { onUpload, onRemoveUpload } = useUploadFile();

  const handleClickSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      console.log({ values });

      let formData = new FormData();
     
      if (fileListDesktop[0]?.file) {
        formData.append("desktop_img", fileListDesktop[0]?.file?.originFileObj);
      }

      formData.append(
        "data",
        JSON.stringify({
          ..._.omit(values, ["desktop_img"]),
          content: contentTextEditor,
          file_delete: fileDelete,
        })
      );

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",

        onOk() {
          return new Promise((resolve, reject) => {
            let actionPathUrl;

            if (match.params.id !== "add") {
              actionPathUrl =
                "/manage-website/award/award/" + match.params.id + "/update";
            } else {
              actionPathUrl = "/manage-website/award/award";
            }

            axios({
              method: "post",
              baseURL: URL_API,
              url: actionPathUrl,
              headers: { Authorization: "Bearer " + getToken() },
              data: formData,
            })
              .then((res) => {
                console.log(res);
                resolve("success");
              })
              .catch((err) => {
                console.log(err);
                reject(
                  err && err.response
                    ? err.response.data.message
                      ? err.response.data.message
                      : err.response.data
                    : err.message
                );
              });
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.goBack();
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  const handleRemoveDesktop = (e) => {
    setFileListDesktop([]);
    if (e.uid?.toString()?.indexOf("rc-upload") === -1) {
      setFileDelete([...fileDelete, e.uid]);
    }
  };

  
  const handleUploadDesktop = async (e) => {
    let isFile = await onUpload(e, true, true);
    if (isFile) {
      setFileListDesktop(isFile);
    }
  };

  const loadContent = () => {
    axios({
      method: "get",
      baseURL: URL_API,
      url: "/manage-website/award/award/" + match.params.id,
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        console.log(res);
        let data = res.data?.data;
        setLoadValue(data);
        console.log(data);
        if (res.data.data) {
          setContentTextEditor(res.data.data.content);
        }

        let { loadDesktopImg } = data;

        for (let i in data.files) {
          if (data.files[i].document_type == "34") {
            loadDesktopImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListDesktop(loadDesktopImg);
          }
        }

        form.setFieldsValue({
          ...data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (match.params.id !== "add") {
      loadContent(match.params.id);
    }
  }, [match.params.id]);

  const { getFieldDecorator } = form;

  return (
    <>
      <Panel>
        <PanelHeader>ประกาศเกียรติคุณ AWARD</PanelHeader>
        <PanelBody>
          <Form.Item layout="vertical">
            <Row className="mb-3" gutter={16}>
              <Col md={12}>
                <Form.Item label="ชื่อรหัสหลัก :">
                  {getFieldDecorator("title", {
                    initialValue: "",
                    rules: [
                      { required: true, message: "กรุณาระบุ ชื่อรหัสหลัก" },
                    ],
                  })(<Input />)}
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label="ชื่อรหัสร่วม :">
                  {getFieldDecorator("description", {
                    initialValue: "",
                    rules: [
                      { required: true, message: "กรุณาระบุ ชื่อรหัสร่วม" },
                    ],
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Row gutter={24} className="mb-2">
                <Col md={12} className="mb-2">
                  <Form.Item label="อัพโหลดรูปนักธุรกิจ : ">
                    {getFieldDecorator("desktop_img", {
                      initialValue: null,
                    })(
                      <Upload.Dragger
                        accept="image/*"
                        multiple={false}
                        fileList={fileListDesktop}
                        customRequest={dummyRequest}
                        beforeUpload={beforeUploadImg}
                        onRemove={handleRemoveDesktop}
                        onChange={handleUploadDesktop}
                        listType="picture"
                      >
                        <AiOutlineUpload className="mr-3" />
                        Upload Image
                      </Upload.Dragger>
                    )}
                  </Form.Item>
                </Col>
                <Col md={12}>
                  {fileListDesktop.length != 0 ? (
                    <Row>
                      <div style={DivStyles}>
                        <img
                          src={fileListDesktop[0].url}
                          alt="desktop_img"
                          style={ImgStyles}
                        />
                      </div>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </Row>

            <Row className="mb-3">
              <p>Content :</p>
              <TextEditor
                authToken={getToken()}
                value={contentTextEditor}
                onInit={(evt, event) => {}}
                onEditorChange={(e) => {
                  setContentTextEditor(e);
                }}
                onUploadSuccess={(json) => {
                  console.log(json);
                }}
                postBody={{ container_name: "web-content" }}
                urlUpload={`${URL_API}/file/upload`}
              />
            </Row>

            <Row gutter={16}>
              <Col md={24}>
                <Button
                  className="bg-nn border-nn text-white mr-3"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Cancel
                </Button>
                <Button type="primary" onClick={() => handleClickSubmit()}>
                  {match.params.id !== "add" ? "Update" : "Save"}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </PanelBody>
      </Panel>
    </>
  );
}
export default Form.create("award-award")(Award);
